import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRIPS_BY_CARGO_ID } from 'api/query-keys.ts';
import type { TripStatusType, TTripForCargoRes } from 'api/swagger';
import { PAGINATION_DEFAULT_LIMIT } from 'shared/constants/paginations';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs.ts';
import type { WithPagination } from 'shared/utils/pagination.ts';
import { preparePagination } from 'shared/utils/pagination.ts';
import type { IWithPagination } from 'types/api-query.ts';

interface ITripFilters {
  statuses?: TripStatusType[];
}

interface IParams extends IWithPagination {
  cargoId: number;
  filters?: ITripFilters;
  enabled?: boolean;
}

export const useGetTripsByCargoId = (params?: IParams) => {
  const { limit = PAGINATION_DEFAULT_LIMIT, page = 1, cargoId, filters, enabled = true } = params || {};

  const qs = new URLSearchParams({ limit: String(limit), page: String(page) });
  if (filters) setFiltersToQs<ITripFilters>(qs, filters);

  return useQuery<WithPagination<TTripForCargoRes[]>>({
    queryKey: [TRIPS_BY_CARGO_ID, cargoId, limit, filters, page],
    queryFn: async () => {
      const { data, headers } = await http.get<TTripForCargoRes[]>(
        `/v1/trips/included-cargo/${cargoId}?${qs.toString()}`,
      );
      const pagination = preparePagination(headers);

      return { data, pagination };
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 0,
    cacheTime: 0,
    enabled,
  });
};
